import store from "../../context/store/store";
import { chatSocketReducerStateModel, chatwindowDetails, contacts, contactwindowDetails, LoginState, recentChatSocketReducerStateModel } from "../../models/model";
import _ from 'lodash';
import { config } from "../constant";
import { Cookie, getcontactDetail, getCookie } from "../utils";
import axios from "axios";
import moment from "moment";
import { SocketChatService } from ".";
import { actionTypes, Types } from "../../context/action/action";
import { shareFileWithMsg } from "../callService/common";
import { toastInformation } from "../callService/common";
import { ChatService } from "../chatService";
import { DraftService } from "../draftService";



export const generateChatID = (fromId:string,userID:string) =>{
    let {userdetails}:LoginState = store.getState().loginReducer;
    const domainId = userdetails.domain_id;
    const Id= (Number(userID) >  Number(fromId) ? userID : fromId) + 
    (Number(userID) >  Number(fromId) ? fromId : userID);
    const chatId = "chat" + Id + domainId;
    return chatId;
}

export const checkInternet = (internet:boolean) =>{
  store.dispatch({
    type: Types.CHECK_INTERNET,
    payloads:{
      internet:internet
    }
  });
  
}


export const SearchRecentSocketChat = (recentChatList: Array<any>, searchText: string) => {
 
    let contactObject: any = store.getState().contactReducer;
    let workContact = contactObject?.workContactsnew;
    let teamContacsnew = contactObject?.teamContacsnew;
    let deleteContacsnew = contactObject?.deleteContacts;
    return recentChatList.filter((element: any) => {
      let personDetails:any =""; 
      if(element?.type === 2){
         personDetails = teamContacsnew["con"+element.chatId];
      } else {
        let toContact = parseInt(element.to);
         personDetails = workContact[toContact] !== undefined? workContact[toContact]:deleteContacsnew[toContact];
      }
      element.id_chat = element.id;
      if(personDetails?.caller_id || personDetails?.team_id){
      let caller_id = personDetails?.caller_id || "";
      //let first_name = personDetails?.first_name || "";
      let last_name = personDetails?.last_name || "";
      let ext = personDetails?.ext || "";
      let team_name = personDetails.team_name || "";
      return (((caller_id).toLowerCase()).startsWith(searchText)|| ((last_name).toLowerCase()).startsWith(searchText) || (ext.toString()).startsWith(searchText)||(team_name.toLowerCase()).startsWith(searchText));
    }
    });
    // return _.filter(Array, function (data: any) {
    //        let caller_id = data.caller_id || "";
    //        let ext = data.ext || "";
    //        return (((caller_id).toLowerCase()).includes(searchText) || (ext.toString()).includes(searchText));
    //      });
  };
export const userInfo = ():{fromID:string,toID:any,domainId:number,
    workContactObj:{[index: number]:any},companyID:string,deviceID:string | null} => {
    let {userdetails}:LoginState = store.getState().loginReducer;
    const domainId = userdetails.domain_id;
    let chatwindowDetails : any = store.getState().chatWindowReducer?.chatWindowDetails;
    let contactObject:any = store.getState().contactReducer;
    let workContactObj = contactObject?.workContactsnew;
    const fromID = userdetails?.sip_login_id;
    const toID = chatwindowDetails?.sip_login_id;
    const companyID = chatwindowDetails?.company_id;
    const deviceID = localStorage.getItem('deviceid');
    return {fromID,toID,domainId,workContactObj,companyID,deviceID}
}



export const SearchAddMemberTeam = (needTosearchArray:Array<any>,searchText:string)=>{
  return _.filter(needTosearchArray, function(data:any) {
    let caller_id = data.caller_id || "";let team_name = data.team_name
    || '';let email_id = data.email_id || "";let ext = data.ext || "";
    return (((caller_id).replace(/\s/g,"").toLowerCase()).includes(searchText)
    ||(ext.toString()).includes(searchText)||(email_id.toLowerCase()).includes(searchText)
    ||(team_name.toLowerCase()).includes(searchText));  
  });
};

export const filesUploadApiSocket = async (files:any,textMessage:string,replyMessageDetails?:any,mention?:any ) => {

  let formData = new FormData();
  let token:any = getCookie("ssoToken");
  let fileText:any =  _.filter(files, function(data:any) {
    return data?.txt !== "" && data?.txt !== undefined
  });

  let cloudFilesUploading = _.filter(files, {'isCloudfiles': true });
  let systemFilesUploading = _.filter(files, {'isCloudfiles': false });
  

  if(cloudFilesUploading.length>0) {
    cloudFilesUploading.map((values:any,index:any)=> { 
      const socketChat = new SocketChatService(userInfo().fromID,userInfo().domainId);
      let chatMiddleLayerdetails= store.getState().chatWindowReducer;
      let {chatWindowDetails, newUserMembers}= chatMiddleLayerdetails|| [];
      let textmsgInfo = files?.length ===1? textMessage?.replace(/<\/?img[^>]*>/g,''): files[index]?.txt;
      
      let mentionInfo = Array.isArray(mention) && mention.length > 0  && systemFilesUploading.length===0 ? mention.toString() : '';
      if(files?.length > 1 && fileText?.length === 0 && textMessage !== "" && index === 0 && systemFilesUploading.length===0){
        textmsgInfo = textMessage
      }
      else { textMessage = ''}

     
      if(Array.isArray(newUserMembers) && newUserMembers.length>0){
        newUserMembers.forEach((value:any,index:number)=>{
        if(value?.sip_login_id){
          socketChat.newMessageFileAttach(values.fileName, values.fileType, values.filesize, values.filePath, value, (newUserMembers.length - 1) === index ? true : false,textmsgInfo,values.isCloudfiles);
          systemFilesUploading.length===0 && chatwindowDetailsPageChange(value);

          }
        else if (value?.team_id) {
          let groupFile:any=  {};
          groupFile.fileName=  values.fileName ;
          groupFile.fileType = values.fileType ;
          groupFile.filesize = values.filesize ;
          groupFile.filePath= values.filePath ;
          groupFile.text = textmsgInfo;
          groupFile.mentionID = index === 0 ? mentionInfo:'';
          groupFile.isCloudfiles =values.isCloudfiles;
          socketChat.sendFileToGroup(groupFile, value, replyMessageDetails,value);
          console.log(mention,"mention")
          systemFilesUploading.length===0 &&  chatwindowDetailsPageChange(value);

          }
        });
      }
      else if(chatWindowDetails?.sip_login_id){
        socketChat.newFileAttach(values.fileName,values.fileType,values.filesize,values.filePath,textmsgInfo,replyMessageDetails,values.isCloudfiles);
      }
      else{
      let groupFile:any=  {};
      groupFile.fileName=  values.fileName ;
      groupFile.fileType = values.fileType ;
      groupFile.filesize = values.filesize ;
      groupFile.filePath= values.filePath ;
      groupFile.text = textmsgInfo;
      groupFile.mentionID = index === 0 ? mentionInfo:'';
      groupFile.isCloudfiles = values.isCloudfiles;
      socketChat.sendFileToGroup(groupFile,chatWindowDetails,replyMessageDetails,values);
      console.log(mention,"mention")
      }
    });
    systemFilesUploading.length===0 &&   store.dispatch({
      type: actionTypes.FILE_ATTACHMENTS,
      payload: {
        filesAttach: [],
        fileUploadingStatus:true
      }
    });
  } else {
    files.map(async(element:any) => {
        formData.append("doc",element.targetFile);
    });
      const url: string = `${config().CHAT_RESTAPI_URL}/upload/files`;
      var authkey = {
        "Content-Type": "application/json",
        Authorization: token   };
      await axios
        .post(url,formData, { headers: authkey })
        .then((res:any) =>{
          if(res.status === 200){
          res.data.files.map((values:any,index:any)=>{
            values.fileName = values.filename;
            values.fileType = values.mimetype;
            values.filesize =  values.size;
            values.filePath =  values.geturl
            values.messageType = "FILE";
            delete values.filename;
            delete values.mimetype;
            delete values.size;
            const socketChat = new SocketChatService(userInfo().fromID,userInfo().domainId);
            let chatMiddleLayerdetails= store.getState().chatWindowReducer;
            let {chatWindowDetails, newUserMembers}= chatMiddleLayerdetails|| [];
            let textmsgInfo = files?.length ===1? textMessage?.replace(/<\/?img[^>]*>/g,''): files[index]?.txt;
            
            let mentionInfo = Array.isArray(mention) && mention.length > 0 ? mention.toString() : '';
            if(files?.length > 1 && fileText?.length === 0 && textMessage !== "" && index === 0){
              textmsgInfo = textMessage
            }
            //let textmsgInfo = (files?.length > 1 && textmInfo === '' && textMessage !== "" && index === 0) ? textMessage :""
           
            if(Array.isArray(newUserMembers) && newUserMembers.length>0){
              newUserMembers.forEach((value:any,index:number)=>{
              if(value?.sip_login_id){
                socketChat.newMessageFileAttach(values.fileName, values.fileType, values.filesize, values.filePath, value, (newUserMembers.length - 1) === index ? true : false,textmsgInfo);
                chatwindowDetailsPageChange(value);
  
                }
              else if (value?.team_id) {
                let groupFile:any=  {};
                groupFile.fileName=  values.fileName ;
                groupFile.fileType = values.fileType ;
                groupFile.filesize = values.filesize ;
                groupFile.filePath= values.filePath ;
                groupFile.text = textmsgInfo;
                groupFile.mentionID = index === 0 ? mentionInfo:''
                socketChat.sendFileToGroup(groupFile, value, replyMessageDetails,value);
                chatwindowDetailsPageChange(value);
  
                }
              });
            }
            else if(chatWindowDetails?.sip_login_id){
              socketChat.newFileAttach(values.fileName,values.fileType,values.filesize,values.filePath,textmsgInfo,replyMessageDetails);
            }
            else{
            let groupFile:any=  {};
            groupFile.fileName=  values.fileName ;
            groupFile.fileType = values.fileType ;
            groupFile.filesize = values.filesize ;
            groupFile.filePath= values.filePath ;
            groupFile.text = textmsgInfo;
            groupFile.mentionID = index === 0 ? mentionInfo:''
            socketChat.sendFileToGroup(groupFile,chatWindowDetails,replyMessageDetails,values);
            console.log(mention,"mention")
            }
          });
          store.dispatch({
          type: actionTypes.FILE_ATTACHMENTS,
          payload: {
            filesAttach: [],
            fileUploadingStatus:true
          }
        });
      }
          })
        .catch((err:any)=>{
          console.log("error---->",err);
          toastInformation('Unsupported file type.Choose another file', 'failure');
        });
  }

}

//socketChat.newFileAttach(value.messageType,value.fileName,value.fileType,value.filesize,value.filePath)
    //   store.dispatch({
    //     type: actionTypes.FILE_ATTACHMENTS,
    //     payload: {
    //       filesAttach: []
    //     }
    //   });
    // )
    export const memberListSearch = (searchArray: any, searchText: any) => {
      return _.filter(searchArray,((item: any) => {
          let caller_id = item.caller_id || "";
          let ext = item.ext || "";
       return (((caller_id.replace(/\s/g, '')).toLowerCase()).includes(searchText)|| (ext.toString()).includes(searchText));
        }));
   };
   /**
   * @description File Upload in API
   * @param file 
   */
export const  fileUploadSocket=async(file:any) =>{    
          let chatSocketReducerState :chatSocketReducerStateModel = store.getState().chatSocketReducerState;
    let fileAttachArray:Array<any> = chatSocketReducerState.filesAttach || [];
    let chatwindowDetails : any = store.getState().chatWindowReducer?.chatWindowDetails;
    const fileAttachtemp = fileAttachArray;
    if(file && fileAttachtemp.length<10){
      fileAttachtemp.push(file);
      DraftService.updateDraftMessage(chatwindowDetails,"",fileAttachtemp);
      store.dispatch({
        type: actionTypes.FILE_ATTACHMENTS,
        payload:{
          filesAttach:fileAttachtemp
        }
      });
      
    }
  }
  export const  fileUploadStricker=async(file:any) =>{    
    //let chatSocketReducerState :chatSocketReducerStateModel = store.getState().chatSocketReducerState;
    const allReducer: any = store.getState().chatReducer;
    let fileAttachArray:Array<any> =  [];
    const fileAttachtemp = fileAttachArray;
    if(file && fileAttachtemp.length<10){
    fileAttachtemp.push(file);
    filesUploadApiSocket(fileAttachtemp, "",allReducer.replyMessageDetails);
   store.dispatch({
      type: actionTypes.EMOJI_WINDOW,
      payload:{
        isEmojiWindow:true
      }
    });
    }
}
  export const sipCallerId = (fromSipId: string) => {
    let {workContactsnew}: contacts = store.getState().contactReducer || [];
    let contactInfo = workContactsnew[fromSipId] || '';
    return contactInfo;
};

export const updateOpenstate =(data:any)=>{
  store.dispatch({
    type: Types.FILE_OPEN_STATE,
    payload: {
      fileOpenMessage: data
    }
  });
  extraChangeMessage();
}
export const extraChangeMessage =()=>{
  let chatSocketReducerState :chatSocketReducerStateModel = store.getState().chatSocketReducerState;

  if(chatSocketReducerState?.messageExtraList?.length !== chatSocketReducerState?.messageList?.length && chatSocketReducerState?.messageExtraList?.length>0){
   // console.log(chatSocketReducerState?.messageExtraList,"chatSocketReducerState")
    store.dispatch({
      type:actionTypes.MESSAGE_LIST,
      payload:{
        messageList :[...chatSocketReducerState?.messageList,...chatSocketReducerState?.messageExtraList]
      }
    })
    store.dispatch({
      type: actionTypes.MESSAGE_EXTRALIST,
      payload:{
          messageExtraList:[]
      }
  })
  }

  
}
export const savedChatListFraming = (saveObject:any) => {
  let {userdetails}:LoginState = store.getState().loginReducer;
  let contactObject:any = store.getState().contactReducer;
  let workContactObj = contactObject.workContactsnew;
  let teamContactobj = contactObject.teamContacsnew;

  let saveRightSide = { ...saveObject };
  saveRightSide.fromDetails =  userdetails?.sip_login_id === saveRightSide?.from  ? userdetails :workContactObj[saveRightSide?.from] && 
      workContactObj[saveRightSide.from];
  if(saveRightSide.chatId.includes('chat')) {
      saveRightSide.toDetails = userdetails?.sip_login_id === saveRightSide?.to ? userdetails : workContactObj[saveRightSide.to] &&
          workContactObj[saveRightSide.to];
  }
  else {
    let teamKey = 'con' + saveRightSide.chatId;
    saveRightSide.toDetails =teamContactobj[teamKey] && teamContactobj[teamKey] ? teamContactobj[teamKey] : {'team_name':"unknown team name"};
  }
  return saveRightSide;
}
  
export const paginationContactSave = (tab:string) => {
  let { contactSavedChatList, isStopPagination,contactLinkList,isLinkPaginationStop }: contactwindowDetails = store.getState().contactWindowReducer;
  if (tab === "fromsavechat") {
    store.dispatch({
      type: Types.CONTACT_SAVED_LOAD,
      payload: {
        isSaveChatLoad: true,
        contactSavedLength: contactSavedChatList.length,
        isStopPagination: isStopPagination
      }
    });
  }
 if (tab === "fromLink")
  {
    store.dispatch({
      type: Types.CONTACT_LINK_LOAD,
      payload: {
        isLinkChatLoad: true,
        contactLinkLength: contactLinkList.length,
        isLinkPaginationStop: isLinkPaginationStop
      }
    });
    
    }
}
export const likeCommonFunction = (likeValue:number,Message:any) => {
  const socketChat = new SocketChatService(userInfo().fromID, userInfo().domainId);
  let input = {
    id: Message.id,
    likeStatus:likeValue
  }
  socketChat.likeMessageInfo(input);    
}

export const saveChatCommonFunction = (status: number, Message: any) => {
  const socketChat = new SocketChatService(userInfo().fromID, userInfo().domainId);
  let isBookmark = {
    id:Message.id,
    saveStatus:status
  };
  socketChat.bookMarkMesseage(isBookmark);
}

export const fileUploadnShareCall = async (files:any,toDetail:any,fileName:string,textMessage?:string) => {
  try {
    const token: any = Cookie.get();
    let ssoToken: any = token["ssoToken"];    
  let formData = new FormData();
  formData.append("doc", files);
    const url: string = `${config().CHAT_RESTAPI_URL}/upload/files`;
    var authkey = {
    "Content-Type": "application/json",
    Authorization: ssoToken
    };
      await axios
    .post(url, formData, { headers: authkey })
    .then((response: any) => {

      if (response.data.statusCode === 200) {
        let values=response.data.files[0]
        let sendData:any= {
        fileName: fileName.toString(),
        fileType :values.mimetype,
       filesize : values.size,
        filePath: values.geturl,
        text : textMessage
        }
          shareFileWithMsg(toDetail,sendData);
      }
    });
} catch (error) { 
  console.log('fileUploadnShareCall error is',error)
}
}


export const handleMute = (e: any, data:any) => {
  const socketChat = new SocketChatService(userInfo().fromID, userInfo().domainId);

  let status = 0;
  let timeStamp:any = '';
  let mutetype = 0;
  if(e.key==="Until 8:00 AM"){
    var now  = new Date();
    now.setDate(now.getDate() + 1)
    now.setHours(8);
    now.setMinutes(0);
    now.setMilliseconds(0);
    timeStamp = moment(now).valueOf();
    status = 1;
    mutetype = 0;
  } else if(e.key==="1 Hr"){
    timeStamp = moment().add(1, 'hours').valueOf();
    status = 1;
    mutetype = 1;
  } else if(e.key==="12 Hr"){
    timeStamp= moment().add(12, 'hours').valueOf();
    status = 1;
    mutetype = 2;
  }else if(e.key==="1 Week"){
    timeStamp= moment().add(7, 'days').valueOf();
    status = 1;
    mutetype = 3;
  }else if(e.key==="Always"){
    timeStamp= moment().add(24, 'hours').valueOf();
    status = 1;
    mutetype = 4;
  } else if(e.key==="Unmute"){
    timeStamp='';
    status = 0;
    mutetype = 5;
  }
 
  let chatDetails = { 
    chatId : data?.sip_login_id ? generateChatID(userInfo().fromID, 
    data?.sip_login_id.toString()): data?.team_id,
    settingsKey : "isMuted",
    toSipId : data?.sip_login_id?data?.sip_login_id.toString():
    data?.team_id.toString(),
    status : status,
    muteTimestamp:timeStamp,
    muteType: mutetype,
    phoneNumber: data?.ext ? data?.ext : "",
    type:data?.sip_login_id ? 1: 2
  };


  
 
  socketChat.updateRecentChatSettings(chatDetails);
}
export const unmuteNotification = (data:any) =>{

  const socketChat = new SocketChatService(userInfo().fromID, userInfo().domainId);
  let chatDetails = { 
    chatId: data?.sip_login_id ? generateChatID(userInfo().fromID, data?.sip_login_id.toString())
      : data?.team_id,
    settingsKey : "isMuted",
    status : 0,
    muteTimestamp:'',
    "muteType": 2,
    phoneNumber:data?.ext ? data?.ext : ""
  };
  socketChat.updateRecentChatSettings(chatDetails);
  // const timer = setTimeout(()=>{
  //   socketService.current.updateRecentChatSettings(chatDetails);socketService.current.toastUndo("","")},3000);
  //   socketService.current.toastUndo("Chat Unmuted Successfully",timer, 'isMuted');
}
export const loadScreen = (status: boolean) => {
  
  let pathName = window.location.pathname;
      store.dispatch({
        type: actionTypes.STARTING_SCREEN,
        payload: {
          startingScreenLoader: status,
          locationName: pathName
      }});

  
};

/* 
new chat one to one and team chat after sending message change purpose
*/
export const chatwindowDetailsPageChange = (currentNewChatDetails:any) => {
  let { isNewMessageWindow, newUserMembers }: chatwindowDetails = store.getState().chatWindowReducer;
  
  if (isNewMessageWindow && Array.isArray(newUserMembers)) {
    const socketChat = new SocketChatService(userInfo().fromID, userInfo().domainId);
    const userDetails = userInfo();
    const toID = currentNewChatDetails?.sip_login_id?.toString() ? currentNewChatDetails?.sip_login_id?.toString() : userDetails?.toID?.toString();
    store.dispatch({
      type: Types.MULTI_NEWMESSAE,
      payload: {
        isMultiNewUserchat: false,
        multiMemberList: []
      }
    });


    setTimeout(() => {
      store.dispatch({
        type: Types.OPEN_NEW_MESSAGE,
        payload: {
          isNewMessageWindow: false,
          newUserMessage: [],
          newUserDetails: []
        }
      });
      if (currentNewChatDetails?.sip_login_id) {
       socketChat.openChatWindow(currentNewChatDetails, "", { chatId: generateChatID(userDetails.fromID, toID) });
        
      }
      else if (currentNewChatDetails?.team_id) {
        socketChat.openChatWindow(currentNewChatDetails)
      }
    }, 300);
  }
  
};
export const allChatNotification = (status: any) => {
  store.dispatch({
    type: Types.CHAT_NOTIFICATIONS,
    payloads: status
  })
};

const changeLikeTimeStamp = (data:any) =>{
  try{
    let likeTymData:any = _.map(data,((o:any)=>{
      if(o?.message?.likedTime  ){
        const objValue:any = Object.values( o?.message?.likedTime )
        const maxTymValue:any = Math.max(...objValue);
        let likedObj:any = { ...o, timestamp:maxTymValue};
        return likedObj
      }
      else return o
    }))
    return likeTymData;
  }
  catch(e:any){ return data; }
} 

export const notificationDataServer = (data:any)=>{
   
  let changeTimeStamp:any = changeLikeTimeStamp(data);
  let {recentChatList} :recentChatSocketReducerStateModel = store.getState().chatSocketRecentReducerState;
  var arr =  Object.values(recentChatList);
   let filterNotify:any = _.filter(arr, ((data: any) => {
    let type = data?.lastmessage?.message;
    return (((data.unreadCount >0) && (type?.messageType === "TASK" || type?.messageType === "NOTE" || type?.messageType === "EVENTS")));
  }));
  
  let uniqeNotificationArray :any =_.uniq([...changeTimeStamp , ...filterNotify]);
  store.dispatch({
    type: Types.CHAT_NOTIFICATIONS,
    payloads:uniqeNotificationArray
  })
};

export const NotifiyRedirect = (data: any) => {

  let userdetails: any = store.getState().loginReducer.userdetails;
  var parseData = data;
  const recentID = (data?.from) !== userdetails?.sip_login_id ? data.from : (data.to) !== userdetails?.sip_login_id ? data.to : "";
  let contact = data?.type === 1? recentID : "con"+data?.chatId;
  let contactsDetail = getcontactDetail(contact);
  const socketservice = new SocketChatService(userdetails.sip_login_id,userdetails.domain_id);
  if(contactsDetail?.sip_login_id){
    let chatDetail = { chatId: generateChatID(userInfo().fromID, contactsDetail.sip_login_id.toString())};
    socketservice.openChatWindow(contactsDetail, "",chatDetail);
    
  } else {
    socketservice.openChatWindow(contactsDetail, "");
  }
  ChatService.openChatWindow(contactsDetail, "");
  let dataRes:any = {chatId:data?.chatId,"id":data.id }
  socketservice.Savehistory(dataRes);
  setTimeout(()=>{
    socketservice.saveChatHighlight(true,parseData);
  }, 1000)
  
};

export const FailedResend = () => {
  let userdetails: any = store.getState().loginReducer.userdetails;
  let contactList :any = store.getState().recentchatReducer;
  const socketservice = new SocketChatService(userdetails.sip_login_id,userdetails.domain_id);
 
  if(Array.isArray(contactList?.failedContact) && contactList?.failedContact?.length>0){
    contactList?.failedContact.forEach((value:any,index:number)=>{
      socketservice.FailedResendChat(value);
      DraftService.removedFailedContact(value,"send");
    });
  }
 
  
}

export const  fileTextAttachment=async(type:any,text:any) =>{    
  let chatSocketReducerState :chatSocketReducerStateModel = store.getState().chatSocketReducerState;
  let fileAttachArray:Array<any> = chatSocketReducerState.filesAttach || [];
      const newMessageList = fileAttachArray.map((value: any,i:any) => {
        if (i=== type) {
          let newMessage = { ...value };
          newMessage["txt"] = text;
          return newMessage;
        } else {
            return value;
        }
        
    });
    store.dispatch({
      type: actionTypes.FILE_ATTACHMENTS,
      payload: {
        filesAttach: newMessageList || []
      }
    });
}

export const chatWindowResize=async(data:any) =>{  
  store.dispatch({
    type: Types.CHAT_WINDOW_RESIZE,
    payload:{
      windowResize: (data - 54)
    }
  });
}

export const chatTeamValidation =async(data:boolean) =>{  
  store.dispatch({
    type: Types.TEAM_VALIDATION,
    payload: {
        teamValidation: data
    }
  });
}

export const teamfinalString = (message:any)=>{
  let finalString = '';
  const fromUser = parseInt(message.from);
  let {workContactsnew}: contacts = store.getState().contactReducer || [];
  let {userdetails}:LoginState = store.getState().loginReducer || [];
  let who = '';
    if (fromUser === parseInt(userdetails?.sip_login_id)) {
        who = 'You';
    } else {
        const fromCaller = workContactsnew[fromUser];
        who = fromCaller?.caller_id ? fromCaller?.caller_id : "Unknown User";
    }

  const members = message?.message?.teamAction?.members.toString().split(',');
  const finalMembers:any = Array.isArray(members) && members?.length > 0 && members.map((value: any) => {
  if (_.isUndefined(workContactsnew[value]) === false) {
      const userD = workContactsnew[value];
      return userD?.caller_id;
  } else {
      return []
  }
});
  if (message?.message?.teamAction?.actionKey === "create_group") {
    finalString = who + ' ' + finalString + message?.message?.teamAction?.description;
} else if (message?.message?.teamAction?.actionKey === "remove_member") {
    finalString = who + " removed " + message?.message?.teamAction?.description + finalMembers.join();
} else if (message?.message?.teamAction?.actionKey === "add_member") {
    finalString = who +  " added " + message?.message?.teamAction?.description + finalMembers.join();
} else if (message?.message?.teamAction?.actionKey === "make_admin") {
    finalString = who +  " make as admin " + message?.message?.teamAction?.description + finalMembers.join();
} else if (message?.message?.teamAction?.actionKey === "make_member") {
    finalString = who + " make as member " + message?.message?.teamAction?.description + finalMembers.join();
} else if (message?.message?.teamAction?.actionKey === "leave_member") {
    finalString = who + " left the group " + message?.message?.teamAction?.description + finalMembers.join();
} else {
    finalString = who + ' ' + finalString + message?.message?.teamAction?.description + finalMembers;
}
return finalString;

}

export const totalTabBatchcount = () =>{  
  let countRes:any = 0;
  let userdetails: any = store.getState().loginReducer.userdetails;
  let { meetingTotalCount } = store.getState().meetingReducer || [];
  let contactObject: any = store.getState().contactReducer;
  let {recentChatList} :recentChatSocketReducerStateModel = store.getState().chatSocketRecentReducerState;
  let unreadCount:any = _.filter(recentChatList, function(value:any) { 
    if(value?.unreadCount>0 && value?.settings?.isDeleted?.["s"+userdetails?.sip_login_id]===0 && value?.settings?.isArchive &&
     value?.settings?.isArchive["s"+userdetails?.sip_login_id]===0 ){
     let textValue = value.type === 2 ? contactObject?.teamContacsnew['con'+value?.chatId] : contactObject?.workContactsnew[value?.to]
     if(textValue !== undefined){
        return value?.unreadCount || 0;
      }
    }
  }); 
  countRes = Number(unreadCount?.length) + Number(meetingTotalCount?.count);
  return countRes;

}